export default {"src":"/login-app/[GIT_HASH]/_next/static/media/materialization.1e053ef5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};